import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offertetable',
  templateUrl: './offertetable.component.html',
  styleUrls: ['./offertetable.component.less']
})
export class OffertetableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
